/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { MetadataEntityPairTraversal } from "./MetadataEntityPairTraversal";
import { MetadataEntityPairResult } from "./MetadataEntityPairResult";
var MetadataEntityPairService = /** @class */ (function () {
    function MetadataEntityPairService(commonDataService, perfService, hopsCount) {
        this.commonDataService = commonDataService;
        this.perfService = perfService;
        this.hopsCount = hopsCount;
        this.retrievedEntityPairs = {};
        this.retrievedEntityDisplayNames = {};
    }
    MetadataEntityPairService.prototype.getAllPathsBetweenEntities = function (entityPairsRequest, cancellationToken) {
        if (!entityPairsRequest.includeToManyRelationship && !entityPairsRequest.includeToOneRelationship) {
            throw new Error("At least one relationship type has to be included.");
        }
        var metadataEntityPairTraversal = new MetadataEntityPairTraversal(this.commonDataService, this.retrievedEntityPairs, this.retrievedEntityDisplayNames);
        return new MetadataEntityPairResult(this.perfService, entityPairsRequest, metadataEntityPairTraversal, cancellationToken, this.hopsCount);
    };
    MetadataEntityPairService.prototype.clearCache = function () {
        this.retrievedEntityPairs = {};
        this.retrievedEntityDisplayNames = {};
    };
    return MetadataEntityPairService;
}());
export { MetadataEntityPairService };
